import { applyFilter, isFilterActive } from './data-table-filter';
import { compareSortValues } from './data-table-sort';
import type { ColumnDef, FilterState, SortState } from './data-table-types';

/**
 * Rândurile cum le arată DataTable în modul client-side: întâi filtrele pe coloane, apoi sortarea. Le folosesc și
 * tabelul, și exporturile care trebuie să iasă identic cu ecranul (ex. /efactura): o singură regulă, nu o copie.
 * Contează doar coloanele primite (cele afișate): filtrul sau sortarea unei coloane ascunse nu se aplică.
 */
export function filterRowsLikeTable<T>(data: T[], columns: ColumnDef<T>[], filters: FilterState): T[] {
  if (Object.keys(filters).length === 0) return data;
  return data.filter((row) => {
    for (const col of columns) {
      if (!col.filter) continue;
      const fv = filters[col.id];
      if (!isFilterActive(fv)) continue;
      const v = col.accessor ? col.accessor(row) : (row as Record<string, unknown>)[col.id];
      if (!applyFilter(v, fv!, col.filter.type)) return false;
    }
    return true;
  });
}

/** Sortarea tabelului (valorile lipsă la sfârșit, vezi `compareSortValues`); fără sortare → ordinea primită. */
export function sortRowsLikeTable<T>(rows: T[], columns: ColumnDef<T>[], sort: SortState): T[] {
  if (!sort) return rows;
  const col = columns.find((c) => c.id === sort.col);
  if (!col || !col.accessor) return rows;
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => compareSortValues(col.accessor!(a), col.accessor!(b), dir));
}
